import axios from './axios';

const viralServices = {
  fetch: () => {
    const options = {
      method: 'GET',
      url: 'virals'
    };

    return axios(options);
  }
};

export default viralServices;
